import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from '@ui/shared/feature-config';
import { CultureMapMapDataService } from './app/services/culture-map-map-data.service';
import { SearchFilterConfigService } from './app/services/filters/search-filter-config.service';
import type { CultureMapItemModel } from './app/entities/culture-map-item.model';
import type { CultureMapFilter } from './app/types/culture-map-filters';
import { AgeGroupSelectFilterConfigService } from './app/services/filters/age-group-select-filter-config.service';
import { CategorySelectFilterConfigService } from './app/services/filters/category-select-filter-config.service';
import { ExperienceTypeSelectFilterConfigService } from './app/services/filters/experience-type-select-filter-config.service';
import { KindSelectFilterConfigService } from './app/services/filters/kind-select-filter-config.service';
import { OfferingMapDataService } from './app/services/data/offering-map-data.service';
import { FacilityMapDataService } from './app/services/data/facility-map-data.service';

bootstrapApplication(AppComponent, createAppConfig<CultureMapItemModel, CultureMapFilter>({
    mapDataStateService: CultureMapMapDataService,
    filterItems: [
        SearchFilterConfigService,
        AgeGroupSelectFilterConfigService,
        CategorySelectFilterConfigService,
        ExperienceTypeSelectFilterConfigService,
        KindSelectFilterConfigService,
    ],
    dataEndpoints: [
        OfferingMapDataService,
        FacilityMapDataService,
    ],
})).catch((err: unknown) => console.error(err));
